import {AfterViewInit, Component, inject, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTable, MatTableModule} from '@angular/material/table';
import {Router, RouterLink} from '@angular/router';
import {
  ApplicationNotification,
  ApplicationsService,
  CatalogResource,
  CatalogsService,
  CreateApplicationData
} from '../../core/modules/openapi';
import {SlicePipe} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatDialog} from "@angular/material/dialog";
import {ApplicationMessagesComponent} from "../application-messages/application-messages.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatCardModule} from "@angular/material/card";
import {CreateApplicationComponent} from "../create-application/create-application.component";
import {CreateApplicationDialogData} from "../../home/home.component";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {ApplicationsTableDataSource, TableItem} from "./applications-data-source";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatSnackBar} from "@angular/material/snack-bar";
import {KeycloakService} from "keycloak-angular";
import {EventSourceService} from "../../services/event-source.service";
import {
  ApplicationCriteriaData,
  ApplicationsSearchComponent
} from "../applications-search/applications-search.component";
import {statusEnumLookup} from "../applications-criteria/applications-criteria.component";
import {CommonService} from "../../services/common.service";

@Component({
  selector: 'app-applications',
  imports: [MatTableModule, MatPaginatorModule, SlicePipe, MatIconModule, MatMenuModule, MatButtonModule, RouterLink, MatTooltipModule, MatCardModule, MatProgressSpinnerModule, MatSortModule, ApplicationsSearchComponent],
  templateUrl: './applications.component.html',
  standalone: true,
  styleUrl: './applications.component.sass'
})
export class ApplicationsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['id', 'personName', 'personIdentifier', 'insuredInterestIdentifier', 'quotationIdentifier', 'inspectionIdentifier', 'companyName', 'status', 'actions'];

  dataSource: ApplicationsTableDataSource;
  readonly messagesDialog = inject(MatDialog);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<TableItem>;
  @ViewChild(ApplicationsSearchComponent) appSearch: ApplicationsSearchComponent;
  insurers: Map<string, CatalogResource> = new Map<string, CatalogResource>();

  constructor(protected readonly router: Router,
              private readonly applicationsService: ApplicationsService,
              private readonly dialog: MatDialog, private snackBar: MatSnackBar,
              protected keycloakService: KeycloakService,
              private readonly eventSourceService: EventSourceService,
              private readonly catalogService: CatalogsService, private readonly commonService: CommonService) {
    this.dataSource = new ApplicationsTableDataSource(applicationsService);
  }

  ngOnInit(): void {
    this.commonService.getInsurersMap().subscribe(insurers => {
      if (insurers) this.insurers = insurers;
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
    this.loadSavedSearchCriteria();
  }

  onMessagesClicked(applicationId: any) {
    this.messagesDialog.open(ApplicationMessagesComponent, {data: {applicationId: applicationId}});
  }

  public createApplication() {
    const dialogRef = this.dialog.open(CreateApplicationComponent, {
      data: {insurer: '', quotationID: ''},
    });

    dialogRef.afterClosed().subscribe((result: CreateApplicationDialogData) => {
      if (!result) return;
      let request: CreateApplicationData = {
        insurer: result.insurer,
        quotationId: result.quotationID
      };
      this.applicationsService.createApplicationFromQuote(request).subscribe(
        response => {
          //this.connectToEventSource();
        },
        error => {
          console.log(error);
        }
      );
      console.log(result);
    });
  }

  connectToEventSource() {
    this.keycloakService.getToken().then(token => {
      this.eventSourceService.connectToServerSentEvents({
        withCredentials: true,
        headers: {'Authorization': 'Bearer ' + token}
      }).subscribe({
        next: (msg) => {
          let notification: ApplicationNotification = JSON.parse(msg);
          this.snackBar.open(notification.title + " - " + notification.description, undefined, {
            duration: 3000
          });
        },
        error: (error) => {
          this.snackBar.open("Imposible obtener estado", undefined, {
            duration: 3000
          });
          this.eventSourceService.close();
        },
        complete: () => {
          this.eventSourceService.close();
        }
      });
    });
  }

  reloadSearch($event: ApplicationCriteriaData | undefined) {
    if ($event) {
      this.dataSource.insurableInterestIdentifier = $event.insurableInterestIdentifier === "" ? undefined : $event.insurableInterestIdentifier;
      this.dataSource.applicantId = $event.insuredId === "" ? undefined : $event.insuredId;
      if ($event.insurerId) {
        this.dataSource.insurerId = $event.insurerId.code;
      } else {
        this.dataSource.insurerId = undefined;
      }
      this.dataSource.status = $event.status;
      this.dataSource.paginator?.firstPage();
    } else {
      this.loadSavedSearchCriteria();
    }
    this.dataSource.criteriaChanged.emit();
  }

  private loadSavedSearchCriteria() {
    let searchCriteriaString = localStorage.getItem('searchCriteria');
    let searchCriteria = searchCriteriaString ? JSON.parse(searchCriteriaString) : undefined;
    if (searchCriteria) {
      this.dataSource.insurableInterestIdentifier = searchCriteria.insurableInterestIdentifier;
      this.dataSource.applicantId = searchCriteria.insuredId;
      this.dataSource.insurerId = searchCriteria.insurerId.code;
      this.dataSource.status = searchCriteria.status;
      this.appSearch.criteriaData = searchCriteria as ApplicationCriteriaData;
    } else {
      console.log("No saved search criteria found");
      this.appSearch.criteriaData = {status: this.dataSource.status} as ApplicationCriteriaData;
    }
  }

  protected readonly statusEnumLookup = statusEnumLookup;
}
